export default {
  form: {
    font_family: {
      label: 'Família de fontes',
    },
    header: {
      label: 'Cabeçalho',
      placeholder: 'Cabeçalho',
    },
    sub_header: {
      label: 'Subcabeçalho',
      placeholder: 'Subcabeçalho',
    },
    qr_code_header: {
      label: 'Cabeçalho da caixa UI',
      placeholder: 'Cabeçalho da caixa UI',
    },
    qr_code_description: {
      label: 'Descrição da caixa UI',
      placeholder: 'Descrição da caixa UI',
    },
    footer: {
      label: 'Texto do rodapé',
      placeholder: 'Introduza o texto do rodapé',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selecionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Cor primária',
    },
    background_color: {
      label: 'Cor de fundo',
    },
    cover_image: {
      label: 'Imagem de capa',
    },
    logo: {
      label: 'Logótipo',
    },
    logo_zoom: {
      label: 'Zoom do logótipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o autocolante de porta',
  },
};
